var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutodeskSvgWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 13.32 13.32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M8.09 0.34c-0.06,-0.06 -0.16,-0.34 -0.54,-0.34l-3.72 0c0,0 0.54,0.06 0.75,0.62 0,0 0.6,1.45 1.13,2.85 1.57,3.8 3.99,9.85 3.99,9.85l3.62 0c0.05,-0.06 -5.18,-12.93 -5.23,-12.98l0 0zm-4.91 0.5l-2.96 7.27c-0.17,0.51 -0.06,1.12 0.8,1.12l2.32 0 2.05 -5.09c-0.65,-1.68 -1.18,-3.02 -1.18,-3.02 -0.06,-0.17 -0.22,-0.62 -0.54,-0.62 -0.33,0 -0.43,0.28 -0.49,0.34l0 0zm-0.05 9.01l-2.48 0c-0.43,0 -0.65,-0.28 -0.65,-0.28 0.43,0.78 1.67,3.24 1.67,3.24 0.22,0.28 0.43,0.45 0.76,0.45 0.7,0 1.78,-0.73 1.78,-0.73l4.15 -2.68 -5.23 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutodeskSvgWhite);
export default __webpack_public_path__ + "static/media/autodesk-svg-white.42af51cf32d2db23aff8e83f6e38a208.svg";
export { ForwardRef as ReactComponent };